import { native, type UserInfo } from '@forest/native-services'
import { createUserInfoSource } from '@forest/paywall-core'
import { shouldUseMockAPI } from '~/lib/params'
import { timed } from '~/lib/perf'

export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (shouldUseMockAPI) {
      return {
        user_type: 'legacy',
        user_id: 1,
        server: 'dev',
        token: 'mock-token',
      } satisfies UserInfo
    }
    // The first native call of the boot: this wait includes the bridge
    // handshake (the perf probe's bridge:ready mark) as well as the call.
    const result = await timed('native:getUserInfo', native.user.getUserInfo())
    if (!result.success || !result.data) {
      throw new Error('failed to get native user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) throw new Error('failed to refresh native token')
    return result.data
  },
})
